export const SHOW_UPDATING_ADDITIONAL_INFO_LOADER = "SHOW_UPDATING_ADDITIONAL_INFO_LOADER";

export interface IMonitoringState {
    isLoading: boolean;
    isUpdatingAdditionalInfo: boolean;
}

export interface ShowUpdatingAdditionalInfoLoaderAction {
    type: "SHOW_UPDATING_ADDITIONAL_INFO_LOADER";
    isUpdatingAdditionalInfo: boolean;
}

export type KnownAction = ShowUpdatingAdditionalInfoLoaderAction;
